import './assets/base.pcss';
import {updateConfig} from "./utils/config";
import {warn} from "./utils/log";
import {loadCSS} from "./utils/css";
import {ready} from "./integration/integration";
import {waitForSetup} from "@@context";
import {injectAutoElement} from "./elements/app";

warn("Fallback mode enabled");

// dynamically configure this module based on the URL parameters of the current page
updateConfig(new URLSearchParams(location.search))
// and config from the module
if (typeof window.__swssConfig === 'object') {
    updateConfig(window.__swssConfig);
}

loadCSS()

async function bootstrap() {
    await waitForSetup
    injectAutoElement()
    ready()
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrap);
} else {
    bootstrap()
}
